import React, { useState, useRef, useEffect } from "react";

function CustomSelect({ value, onChange, options, className, disabled }) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find((opt) => opt.value === value) || options[0];

  return (
    <div className={`custom-select-container ${className || ""}`} ref={containerRef}>
      <div
        className={`custom-select-trigger ${disabled ? "disabled" : ""}`}
        onClick={() => {
          if (disabled) return;
          setIsOpen(!isOpen);
        }}
        title={disabled ? "Select a project first" : undefined}
      >
        <span>{selectedOption ? selectedOption.label : ""}</span>
        <svg
          className={`custom-select-arrow ${isOpen ? "open" : ""}`}
          width="10"
          height="6"
          viewBox="0 0 10 6"
          fill="none"
        >
          <path
            d="M1 1L5 5L9 1"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      {isOpen && !disabled && (
        <div className="custom-select-options-list">
          {options.map((opt) => (
            <div
              key={opt.value}
              className={`custom-select-option ${opt.value === value ? "selected" : ""} ${
                opt.disabled ? "disabled" : ""
              }`}
              onClick={() => {
                if (opt.disabled) return;
                onChange(opt.value);
                setIsOpen(false);
              }}
            >
              {opt.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomSelect;
